export enum IntegrationsPartnerEnum {
    OrderOut = 'OrderOut',
}